<template>
<div class="wg-location style-1">
    <div class="themesflat-container top">
      <div class="row">
        <div class="col-12">
          <div class="content">
            <div class="heading-section text-center">
              <div class="sub">{{ $t("location") }}</div>
              <div class="main" :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ $t("how_to_find_us") }}</div>
              <div class="text" style="padding-left: 25%;padding-right: 25%;">
                {{ franchise.location_description }}
              </div>
              <div class="divider"><div></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="widget-tabs style-1">
      <div class="widget-content-tab">
        <div class="widget-content-inner active">
          <div class="themesflat-container">
            <div class="row">
              <FranchiseMapComponent />
              <ContactDetailsComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";
import FranchiseMapComponent from "./FranchiseMapComponent.vue";
import ContactDetailsComponent from "./ContactDetailsComponent.vue";

export default {
  name: "LocationComponent",
  components: {
    FranchiseMapComponent,
    ContactDetailsComponent
  },

  data() {
    return {
      langStore,
      franchise: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchLocation();
    },
  },

  mounted() {
    this.fetchLocation();
  },

  methods: {
    async fetchLocation() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/franchise`,
          { params: { lang: this.langStore.lang } }
        );

        this.franchise = response.data;
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
  },
};
</script>

<style scoped>
.content p {
  padding-left: 30%;
  padding-right: 30%;
}
</style>
